
export enum AppMutationTypes {
    SET_LANGUAGE = 'SET_LANGUAGE',
  }
  